<div class="flex flex__align-items--center flex--column">
  <h1 textSize="14" textWeight="bold" >Notification</h1>
  <p>
    {{ data.content }}
  </p>
</div>


